import PageLayout from "@/components/PageLayout";
import FAQ from "@/components/FAQ";

export default function FAQPage() {
  return (
    <PageLayout>
      <div data-testid="faq-page" className="pt-24">
        <FAQ />
      </div>
    </PageLayout>
  );
}
